var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" Login successful"),_c('br'),_vm._v(" Your browser should be redirected soon... ")])])
}]

export { render, staticRenderFns }